export const MODULE_CONTATO = 1;
export const MODULE_PEDIDOS_IMPORTADOR = 2;